export default "__VITE_ASSET__Cvy$jLsf__"